import color from 'atoms/colors/colors';
import shadow from 'atoms/shadows/shadows';

const trackStyles = {
  borderRadius: 4,
  height: 8,
  backgroundColor: color.wave[800],
  borderWidth: 0,
};

const thumbStyles = {
  width: 24,
  height: 24,
  border: `1.5px solid ${color.wave[800]}`,
  boxShadow: shadow.md,
  '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
    boxShadow: 'inherit',
  },
  '&:before': {
    display: 'none',
  },
};

const railStyles = {
  borderRadius: 4,
  height: 8,
  opacity: 1,
};

const labelStyles = {
  lineHeight: 1.5,
  background: 'unset',
  padding: '8px 12px',
  borderColor: color.bubbles[50],
  borderStyle: 'solid',
  borderRadius: 8,
  borderWidth: 0,
  backgroundColor: color.common.white,
  color: color.storm[900],
  '&:before': { display: 'none' },
};

const invertedTrack = {
  height: 8,
};

export const lightSlider = {
  MuiSlider: {
    styleOverrides: {
      root: {
        '&.MuiSlider-trackInverted .MuiSlider-track': {
          backgroundColor: color.cloud[200],
          borderColor: color.cloud[200],
          ...invertedTrack,
        },
        '&.MuiSlider-trackInverted .MuiSlider-rail': {
          color: color.storm[600],
        },
      },
      thumb: {
        color: color.common.white,
        ...thumbStyles,
        '&.Mui-disabled': {
          color: color.cloud[200],
        },
      },
      track: {
        color: color.storm[600],
        ...trackStyles,
      },
      rail: {
        color: color.cloud[200],
        ...railStyles,
      },
      valueLabel: {
        ...labelStyles,
      },
    },
  },
};

export const darkSlider = {
  MuiSlider: {
    styleOverrides: {
      root: {
        '&.MuiSlider-trackInverted .MuiSlider-track': {
          backgroundColor: color.cloud[700],
          borderColor: color.cloud[700],
          ...invertedTrack,
        },
        '&.MuiSlider-trackInverted .MuiSlider-rail': {
          color: color.storm[600],
        },
      },
      thumb: {
        color: color.cloud[50],
        ...thumbStyles,
        '&.Mui-disabled': {
          color: color.cloud[700],
        },
      },
      track: {
        color: color.storm[600],
        ...trackStyles,
      },
      rail: {
        color: color.cloud[700],
        ...railStyles,
      },
      valueLabel: {
        ...labelStyles,
      },
    },
  },
};
